import React, { ReactElement, useEffect, useRef, FC } from 'react'

import { SeatsPerParty } from 'types/gemeindeRatSitzeFile'
import { ParliamentTableRow } from './parliamentTableRow'
interface Props {
  seatsPerParty: SeatsPerParty
}
export const ParliamentTable: FC<Props> = ({ seatsPerParty }): ReactElement => {
  const sortedSeatsPerParty = seatsPerParty.sort(
    (resultA, resultB) => resultB.seats - resultA.seats
  )
  return (
    <div id='parliament-table'>
      <div id='table-head'>
        <div>Parti</div>
        <div>Sièges</div>
      </div>
      <div>
        {sortedSeatsPerParty.map(row => (
          <ParliamentTableRow
            key={row.party}
            color={row.color}
            party={row.party}
            seatsNew={row.seats}
            seatsDisplay={row.seatsDisplay}
            seatsChange={row.changeSeats}
          />
        ))}
      </div>
      {/* <small><b>Note</b>: Les formations du centre regroupées font le même score qu’en 2017</small> */}
    </div>
  )
}
